import { useEffect as e, useState as t } from "react";
//#region src/lib/useIsCoarsePointer.ts
var n = "(pointer: coarse) and (hover: none)";
function r() {
	return typeof window.matchMedia == "function" && window.matchMedia(n).matches;
}
function i() {
	let [i, a] = t(r);
	return e(() => {
		if (typeof window.matchMedia != "function") return;
		let e = window.matchMedia(n);
		a(e.matches);
		let t = (e) => a(e.matches);
		return e.addEventListener("change", t), () => e.removeEventListener("change", t);
	}, []), i;
}
//#endregion
export { i as useIsCoarsePointer };

//# sourceMappingURL=useIsCoarsePointer.js.map